export enum RiskModel {
    /**
     * Modelo 1 de Risco
     */
    One = 1,

    /**
     * Modelo 2 de Risco
     */
    Two = 2
}